import React from 'react';
import Modal from 'react-bootstrap/Modal';

export interface CustomModalProps {
    show: boolean;
    onHide: () => void;
    body: JSX.Element;
    title: React.ReactNode;
    footer?: JSX.Element;
    onEntered?(node: HTMLElement, isAppearing: boolean): any;
    size?: 'sm' | 'lg' | 'xl';
    centered?: boolean;
}

const CustomModal = ({
    show,
    onHide,
    body,
    title,
    footer,
    onEntered,
    size,
    centered,
}: CustomModalProps): JSX.Element => {
    return (
        <Modal show={show} onHide={onHide} onEntered={onEntered} size={size} centered={centered}>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{body}</Modal.Body>
            {footer && <Modal.Footer>{footer}</Modal.Footer>}
        </Modal>
    );
};

export default CustomModal;
